export default __webpack_public_path__ + "static/img03-767981254583b9fd40ccfd11b54f55e1.webp";